import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M7.5 7.5h.01M2 4v6.172a2 2 0 0 0 .586 1.414l8.586 8.586a4 4 0 0 0 5.656 0l3.344-3.344a4 4 0 0 0 0-5.656l-8.586-8.586A2 2 0 0 0 10.172 2H4a2 2 0 0 0-2 2"
    }, null, -1)
  ])))
}
export default { render: render }